import React from 'react';
import { Edit, DisabledInput } from 'react-admin';
import SubsectorForm from '../SubsectorForm';

function SubsectorEdit(props) {
  return (
    <Edit undoable={false} {...props}>
      <SubsectorForm redirect="list">
        <DisabledInput label="Id" source="id" />
      </SubsectorForm>
    </Edit>
  );
}

export default SubsectorEdit;
